<template>
  <div class="text-left row">

    <div class="col-12 ">
      <div class="row">
        <div class=" col-sm-12 col-lg-3 mt-2">
          <the-mask id="numero" :mask="['(##) ####-####', '(##) #####-####']" v-model="filtro.numero" class="form-control" placeholder="Número"/>
        </div>

        <div class=" col-sm-12 col-lg-2 mt-2 ">
          <datepicker
            calendar-class="form-control"
            v-model="filtro.dataInicio"
            input-class="form-control col-12 "
            placeholder="Data inicio"
            wrapper-class="fullscreen-when-on-mobile"
            :width="100"
            :language="ptBR"
            style="color: #000">
          </datepicker>
        </div>

        <div class=" col-sm-12 col-lg-2 mt-2">
          <datepicker
            calendar-class="form-control"
            v-model="filtro.dataFim" 
            input-class="form-control col-12"
            placeholder="Data fim"
            wrapper-class="fullscreen-when-on-mobile"
            :width="100"
            :language="ptBR"
            calendar-button-icon="fas fa-badge-check"
            style="color: #000">
            
          </datepicker> 
        </div> 

        <div class="col-sm-12 col-lg-5 mt-2">
          <div class="row">
            <div class="col-12 col-md-7 mb-2">
              <button class="btn btn-info col-12 btn-md" @click="listAll()" title="filtrar">
                <font-awesome-icon icon="search" class="pointer" /> Buscar
              </button>
            </div>
            <div class="col-12 col-md-5">
              <button class="btn btn-success col-12 btn-md" @click="download()" title="filtrar" :disabled='lista.length == 0'>
                <font-awesome-icon icon="download" class="pointer"/>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="alert mt-4 alert-warning col-12" v-if="lista.length == 0">
        <strong>Atenção!</strong> Nenhum retorno encontrado
      </div>

      <div class="row mt-4">
        <div class="col">
          <table class="table table-dark table-striped table-sm table-responsive-lg">
            <thead class="thead-dark">
              <tr>
                <th width="130px" scope="col">Data do retorno</th>
                <th width="130px" scope="col">Número</th>
                <th width="130px" scope="col">Mensagem enviada</th>
                <th width="130px" scope="col">Mensagem recebida</th>
              </tr>
            </thead>
            <tbody>
            <tr v-for="item in lista" :key="item._id">
              <td> {{item.data | datetime}} </td>
              <td> {{item.numero | phone}} </td>
              <td> {{item.sms.mensagemInteira}} </td>
              <td> {{item.mensagem}} </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <my-pagination
        :total='totalItens'
        :perPage="limit"
        @pageChanged='listAll($event.skip,$event.limit)'
      ></my-pagination>
    </div>
  </div>

</template>

<script>

import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { ptBR } from 'vuejs-datepicker/dist/locale';

export default {
  data() {
    return {
      ptBR: ptBR,
      lista: [],
      filtro: {
        search: '',
        dataInicio: new Date(),
        dataFim: new Date(),
      },
      totalItens:0,
      skip:0,
      limit: 20,
    }
  },
  methods: {
    async listAll(skip, limit){

      this.filtro.skip = skip ? skip : this.skip;
      this.filtro.limit = limit ? limit : this.limit;
      let response = await this.$http.post(`/v1/v3/retornos/`, this.filtro);
      if (response.data) {
        this.lista = response.data;
        this.totalItens = response.total;
      }
    },
    async download(skip, limit){

      this.filtro.skip = skip ? skip : this.skip;
      this.filtro.limit = limit ? limit : this.limit;

      let response = await this.$http.post(`/v1/v3/retornos/download`, this.filtro);
      if (response.success) {
        window.location.href = process.env.VUE_APP_APIV2 + '/uploads/temp/' + response.path;
      } else {
        this.$toasted.show(response.err, { icon: 'times', type: 'error' });
      }
    }
  },
  async mounted() {
    this.listAll();
  },
  components: {
    Datepicker
  }

};
</script>

